import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { defaultOrgName } from '@/features/org/utils/default-org-name';
import { PartnerPopulated } from '@/features/partners/api/get-partners';
import { useUpdatePartner } from '@/features/partners/hooks/use-update-partner';
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { LabelInput } from '@/shared/components/ui/label-input';

type ChangeAliasDialogProps = {
  isOpen?: boolean;
  onClose: () => void;
  partner?: PartnerPopulated;
};

export const ChangeAliasDialog = ({
  isOpen = false,
  onClose,
  partner,
}: ChangeAliasDialogProps) => {
  const [alias, setAlias] = useState<string | undefined>(partner?.alias);
  const { t } = useTranslation('partner', { keyPrefix: 'PartnerHub' });
  const { t: common_t } = useTranslation('common');
  const { mutate } = useUpdatePartner();

  const onSubmit = () => {
    if (!partner) return;

    mutate({
      partnerId: partner.id,
      updateDto: {
        alias: alias,
      },
    });
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={() => {
        setAlias(undefined);
        onClose();
      }}
    >
      <DialogContent>
        <DialogTitle>{t('change_alias_title')}</DialogTitle>
        <div className="flex flex-col space-y-4 pt-6">
          <div>
            <LabelInput
              label={partner?.organization.name ?? ''}
              className="text-center"
              disabled
              placeholder={partner?.organization.name ?? defaultOrgName}
            />
          </div>
          <div className="pb-6">
            <LabelInput
              label={t('change_alias_label')}
              value={alias ?? partner?.alias ?? ''}
              onChange={(e) => setAlias(e.target.value)}
              className="text-center"
              placeholder={t('change_alias_placeholder')}
            />
          </div>
          <Button onClick={onSubmit} variant={'greenGradient'}>
            {common_t('button.save')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
